import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const LearningTable = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 10px;
  padding: 4px 0;
  border-bottom: 1px solid rgba(45, 54, 83, 0.2);
  
  &:last-child {
    border-bottom: none;
  }
`;

const LearningLabel = styled.div`
  color: #2D3653;
  font-family: 'IBM Plex Sans JP', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${props => props.fontSize ? `clamp(${props.fontSize}px, 1vw, ${props.fontSize}px)` : 'clamp(14px, 1vw, 18px)'};
`;

const LearningValue = styled.div`
  color: #2D3653;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${props => props.fontSize ? `clamp(${props.fontSize}px, 1vw, ${props.fontSize}px)` : 'clamp(14px, 1vw, 18px)'};
`;

const PanelTitle = styled.h2`
  color: #2D3653;
  text-align: center;
  font-family: 'Style Script', cursive;
  font-size: clamp(16px, 1.5vw, 24px);
  margin-bottom: 0px;
  margin-top: 0px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 0;
  }
`;



const DailyLearningContainer = ({ dailyLearning, fontSize }) => {
  const { t } = useTranslation();

  if (!dailyLearning?.dailyLearning) {
    return null;
  }

  const formatLearningCategory = (key) => {
    switch (key) {
      case 'mishnaYomi':
        return t('display.mishnaYomi');
      case 'dafYomi':
        return t('display.dafYomi');
      case 'psalms':
        return t('display.psalms');
      default:
        return key;
    }
  };

  return (
    <>
      <PanelTitle>{t('display.dailyLearning')}</PanelTitle>
      <Container>
        {Object.entries(dailyLearning.dailyLearning).map(([key, value]) => (
          <LearningTable key={key}>
            <LearningLabel fontSize={fontSize}>
              {formatLearningCategory(key)}
            </LearningLabel>
            <LearningValue fontSize={fontSize}>
              {value}
            </LearningValue>
          </LearningTable>
        ))}
      </Container>
    </>
  );
};

export default DailyLearningContainer; 